module.exports = __webpack_public_path__ + "static/media/sound.06361bc0.mp3";